import React from 'react';
import loading from "../assets/loading.svg";
export function Loading() {
    return (
      <div className="spinner">
        <img src={loading} alt="Loading" />
      </div>
    );
  }
  
  export const formatDuration = (durationStr) => {
    if (!durationStr) return "Unknown duration";
    
    // Convert string to number
    const minutes = parseInt(durationStr, 10);
    if (isNaN(minutes)) return "Unknown duration";
    
    if (minutes < 60) return `${minutes}min`;
    
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    
    if (remainingMinutes === 0) return `${hours}h`;
    return `${hours}h ${remainingMinutes}min`;
};
